module.exports = __webpack_public_path__ + "static/img/Downloader.la-6601ec0085b75.3a970b1d.jpg";